import settingsApi from '@/api/settings';
import {mutationTypes} from '@/store/modules/settings/mutations';

export const actionsTypes = {
  getSEOParams: '[settings] get SEO params',
  getInstanceSettings: '[settings] get instance',
  getReportSettings: '[settings] get report',
  getEmailTemplateSettings: '[settings] get email template',
  getWebsocketUrl: '[settings] get websocket url',
};

const actions = {
  [actionsTypes.getSEOParams](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getSEOParamsStart);
      settingsApi
        .getSEOParams()
        .then((response) => {
          context.commit(mutationTypes.getSEOParamsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getSEOParamsFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getInstanceSettings](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getInstanceSettingsStart);
      settingsApi
        .getInstanceSettings()
        .then((response) => {
          context.commit(mutationTypes.getInstanceSettingsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getInstanceSettingsFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getReportSettings](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getReportSettingsStart);
      settingsApi
        .getReportSettings()
        .then((response) => {
          context.commit(mutationTypes.getReportSettingsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getReportSettingsFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getEmailTemplateSettings](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getEmailTemplateSettingsStart);
      settingsApi
        .getEmailTemplateSettings()
        .then((response) => {
          context.commit(mutationTypes.getEmailTemplateSettingsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getEmailTemplateSettingsFailure,
            result.response.data.message
          );
          reject(result);
        });
    });
  },
  [actionsTypes.getWebsocketUrl](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getWebsocketUrlStart);
      settingsApi
        .getWebsocketUrl()
        .then((response) => {
          context.commit(mutationTypes.getWebsocketUrlSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getWebsocketUrlFailure);
          reject(result);
        });
    });
  },
};

export default actions;
